import { render, staticRenderFns } from "./AccordionCard.vue?vue&type=template&id=19205052&"
import script from "./AccordionCard.vue?vue&type=script&lang=ts&"
export * from "./AccordionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19205052')) {
      api.createRecord('19205052', component.options)
    } else {
      api.reload('19205052', component.options)
    }
    module.hot.accept("./AccordionCard.vue?vue&type=template&id=19205052&", function () {
      api.rerender('19205052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/components/AccordionCard.vue"
export default component.exports